module.exports = __webpack_public_path__ + "img/NI.1b9febc8.png";